export const stream = {
    streamConfig: "ตั้งค่าสตรีม",
    accumulateDeposit: "ยอดเงินฝากสะสม",
    create:"สร้าง",
    update:"อัพเดด",
    streamer:{
      topic:"สตรีมเมอร์",
      create:"สร้าง",
      id:"id",
      operatorId:"Operator Id",
      name:"ชื่อ",
      imageUrl:"Image Url",
      description:"รายละเอียด",
      isActive:"Is Active",
      createdAt:"Created At",
      updatedAt:"Updated At"
    },
streaming:{
      topic:"สตรีมมิ่ง",
      create:"สร้าง",
      id:"Id",
      operatorId:"Operator Id",
      streamerId:"Streamer Id",
      streamingName:"Streaming Name",
      streamingDetail:"Streaming Detail",
      streamingUrl:"Streaming Url",
      streamingKey:"Streaming Key",
      playerThumbnailUrl:"Player Thumbnail Url",
      isActive:"Is Active",
      createdAt:"Created At",
      updatedAt:"Updated At",
      }
  };
  